import { CloudProvider } from 'portal-shared-lib';

export class Provider {
    providerData: CloudProvider;
    imgSrc: string;

    constructor(providerData: CloudProvider, imgSrc: string) {
        this.providerData = providerData;
        this.imgSrc = imgSrc;
    }

    public hasRegions(): boolean {
        return this.providerData.regionsList.length >= 1;
    }
}



// WEBPACK FOOTER //
// ./src/webportal/models/filespace/provider.ts